<script>
import { mapGetters } from 'vuex';

import { formatAmount } from '../lib/formatters';

export default {
  props: {
    paymentType: {
      type: String,
      required: true
    },
    isProductOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    withSymbol: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'productDiscountedAmount',
      'productAmount',
      'productFirstRecurrenceDiscountedAmount',
      'productFirstRecurrenceAmount',
      'totalDiscountedAmount',
      'totalAmount',
      'totalFirstRecurrenceDiscountedAmount',
      'totalFirstRecurrenceAmount'
    ]),

    isDiscounted() {
      return this.amount != this.discountedAmount;
    },

    amount() {
      if (this.isProductOnly) {
        return this.isPayAtOnce ? this.productAmount : this.productFirstRecurrenceAmount;
      }
      return this.isPayAtOnce ? this.totalAmount : this.totalFirstRecurrenceAmount;
    },

    discountedAmount() {
      if (this.isProductOnly) {
        if (this.isPayAtOnce) {
          return this.productDiscountedAmount;
        } else {
          return this.productFirstRecurrenceDiscountedAmount;
        }
      }

      if (this.isPayAtOnce) {
        return this.totalDiscountedAmount;
      } else {
        return this.totalFirstRecurrenceDiscountedAmount;
      }
    },

    formattedAmount() {
      return this.formatAmount(this.amount);
    },

    formattedDiscountedAmount() {
      return this.formatAmount(this.discountedAmount);
    },

    isPayAtOnce() {
      return this.paymentType == 'pay_at_once';
    }
  },

  methods: {
    formatAmount(amount) {
      if (amount === 0) {
        return this.t('pay.js.marketing.summary.free');
      } else {
        return formatAmount(amount, this.withSymbol);
      }
    }
  }
};
</script>

<template>
  <div v-if="isDiscounted">
    <del class="c-summary__amount--deleted">
      {{ formattedAmount }}
    </del> {{ formattedDiscountedAmount }}
  </div>

  <div v-else>
    {{ formattedAmount }}
  </div>
</template>
